import { SUPPORT_EMAIL } from '@shared/constants';

export enum ApiErrors {
  CategoriesAreInconsistent = 'FormInstanceError.CategoriesAreInconsistent',
  QuestionsAreInconsistent = 'FormInstanceError.QuestionsAreInconsistent',
  SummaryIsInconsistent = 'FormInstanceError.SummaryIsInconsistent',
  QuizInstanceNotStarted = 'QuizInstanceNotStarted',
  SuperUserSiteSwitchNotPermitted = 'SuperUserSiteSwitchNotPermitted',
  InvalidCadSalesforceId = 'CadImport.InvalidSalesforceId',
  ConnectorIdRequired = 'CadImport.ConnectorIdRequired',
  ConnectorIdInvalid = 'CadImport.ConnectorIdInvalid',
  IncorrectPassword = 'PasswordValidationError.IncorrectPassword',
  UnsafePassword = 'PasswordValidationError.UnsafePassword',
  PasswordSameAsOldPassword = 'PasswordValidationError.PasswordSameAsOldPassword',
  NoPowerDMSUserId = 'FoundationError.NoPowerDMSUserId',
  UserNotFound = 'FoundationError.UserNotFound',
  SiteNotEnabledForSSO = 'FoundationError.SiteNotEnabledForSSO',
  LoginWithSSO = 'FoundationError.LoginWithSSO',
  GenericSSOError = 'FoundationError.GenericSSOError',
  SuperUserCannotCreateUsers = 'FoundationError.SuperUserCannotCreateUsers',
  CannotResetPassword = 'FoundationError.CannotResetPassword',
  MultipleUserRecordsWithSameEmail = 'FoundationError.MultipleUserRecordsWithSameEmail',
  MaxStorageExceeded = 'StorageError.MaxStorageExceeded',
  MaxUploadSizeForFileExceeded = 'StorageError.MaxUploadSizeForFileExceeded',
  DuplicateEntry = 'SiteAdministrationError.DuplicateEntry'
}

export const ApiErrorsMessage = {
  [408]: 'Request timed out. Please try again.',
  [500]: `Loading failed, please contact customer support at ${SUPPORT_EMAIL} with this request ID {{TRACE_ID}}`,
  [ApiErrors.CategoriesAreInconsistent]: 'Categories are Inconsistent',
  [ApiErrors.QuestionsAreInconsistent]: 'Questions are Inconsistent',
  [ApiErrors.SummaryIsInconsistent]: 'Summary is Inconsistent',
  [ApiErrors.InvalidCadSalesforceId]: 'Invalid Neogov Account ID',
  [ApiErrors.ConnectorIdRequired]: 'CAD Connector ID is required',
  [ApiErrors.ConnectorIdInvalid]: 'CAD Connector ID is invalid',
  [ApiErrors.IncorrectPassword]: 'The password you entered did not match our records. Please try again',
  [ApiErrors.UnsafePassword]:
    'This password was identified as unsafe. Using this password will put the account at high risk of compromise. Please change your password.',
  [ApiErrors.PasswordSameAsOldPassword]: 'Your new password cannot be the same as your current password.',

  [ApiErrors.NoPowerDMSUserId]:
    'User could not be authenticated, no user ID was returned.  Please try again or contact your system administrator.',
  [ApiErrors.UserNotFound]: 'No matching PowerReady user found.  Please login using a user with access to PowerReady.',
  [ApiErrors.SiteNotEnabledForSSO]:
    'Site not enabled to use PowerDMS SSO. Please contact your system administrator to use this feature.',
  [ApiErrors.LoginWithSSO]: 'Please login with your PowerDMS account.',
  [ApiErrors.GenericSSOError]:
    'An unknown error occurred during the PowerDMS SSO login. Please try again or contact your system administrator.',
  [ApiErrors.SuperUserCannotCreateUsers]:
    'This site is enabled for PowerDMS Login and User Synchronization. Super Users can not perform user creation.',
  [ApiErrors.CannotResetPassword]:
    'Your site is enabled for PowerDMS Login, password resets must be initiated through the PowerDMS login screen',
  [ApiErrors.MultipleUserRecordsWithSameEmail]: 'Please enter your site ID to login',
  [ApiErrors.MaxStorageExceeded]: 'Upload failed. Storage limit exceeded',
  [ApiErrors.MaxUploadSizeForFileExceeded]: 'Maximum upload size for file exceeded.'
};
